import { db, auth, functions  } from "../../firebase/firebase";
import {
  doc,
  setDoc,
  getDoc,
  addDoc,
  updateDoc,
  deleteDoc,
  collection,
  getDocs,
  QueryDocumentSnapshot,
  query,
  where,
  limit,
  startAfter,
  QueryConstraint,
  or,
  and,
  QueryCompositeFilterConstraint,
  QueryNonFilterConstraint,
  Timestamp,
  WhereFilterOp
} from "firebase/firestore";




import { MemberInvite, MemberInvitePayload } from "../../models/ChannelMember";
import { CustomError, isError } from "../../utils/customeError";
import { SKUser } from "../../models/SKUser";
import { InviteStatus, UserInvite } from "../../models/UserInvite";
import { httpsCallable } from "firebase/functions";


// Firestore services

const inviteMember = async (data: MemberInvitePayload) : Promise<string> => {
  try {
    let inviteData = {...data, createdDate: Timestamp.now(), updatedDate: Timestamp.now(), invitedBy: auth.currentUser?.displayName}
    let ref = await addDoc(collection(db, "storeInvites"), inviteData);
    return ref.id
  } catch (error) {
    console.log(error)
    throw new CustomError('An error occurred while creating Artefact');
  }
  
};



const setUserClaim = async (userId:string, role:string): Promise<any> => {
  const setMyUserClaim = httpsCallable(functions, 'setUserClaim');
  try {
    const result = await setMyUserClaim({userId,role});
    console.log('User Role and Permissions:', result.data);
    return result
  } catch (error) {
    console.error('Error fetching user role and permissions:', error);
    throw new CustomError('Error fetching user role and permissions:');
  }
};


const acceptInvitation = async (inviteId: string): Promise<void> =>  {
  return await updateDoc(doc(db, "storeInvites", inviteId), {status:InviteStatus.accepted, userId:auth.currentUser?.uid});
};
const acceptSkarvoOperatorInvitation = async(invitationId:string) =>{
    const setClaimIfSkarvoInvitation = httpsCallable(functions, 'setClaimIfSkarvoInvitation');
    setClaimIfSkarvoInvitation({
      invitationId
    }).then((result) => {
      console.log(result.data);
      return result
    }).catch((error) => {
      console.error('Error joining as Skarvo operator', error.message);
      throw new CustomError('Error joinning');
    });
}


const acceptChannelInvitationAndJoin = async ( invitationId:string, channelId:string): Promise<any> => {
  const setUserClaimAndJoinChannel = httpsCallable(functions, 'setUserClaimAndJoinChannel');
  setUserClaimAndJoinChannel({
    channelId,
    invitationId
  }).then((result) => {
    console.log(result.data);
    return result
  }).catch((error) => {
    console.error('Error joining channel', error);
    throw new CustomError('Error joinning channel:');
  });
};

const acceptInvite = async ( invitationId:string ) : Promise<void> => {
  try {
    //await addDoc(collection(db, COLLECTIONS.FEEDS, invitationId, "statusHistory" ), {status:"created", createdDate: Timestamp.now()} );
  } catch (error) {
    console.log(error)
    throw new CustomError('An error occurred while creating Artefact');
  }
};

const getInviteDetail = async ( invitationId:string ) : Promise<UserInvite> => {
  const docSnap = await getDoc(doc(db, "storeInvites", invitationId));
  if (docSnap.exists()) {
    return docSnap.data() as UserInvite;
  } else {
    throw new CustomError('An error occurred while getting user');
  }
};

const getInvitedMember = async (userId: string) : Promise<MemberInvite> => {
    const docSnap = await getDoc(doc(db, "storeInvites", userId));
    if (docSnap.exists()) {
        return docSnap.data() as MemberInvite;
    } else {
        throw new CustomError('An error occurred while getting user');
    }
};


const fetchMyInvitations = async (pageSize: number, lastDocument?:QueryDocumentSnapshot, isFlagged?:boolean ): Promise<MemberInvite[]> => {

  let ref = collection(db, "storeInvites")
  
  // let myQuery: QueryConstraint[] = []
  // myQuery.push(where(filterField, operator as WhereFilterOp, filterValue))

  let myNonFilterQuery: QueryNonFilterConstraint[] = []

  myNonFilterQuery.push(limit(pageSize ?? 10))

  //where("categories.entertainment", "==", true)
  let constraints = [ where("email", "==", auth.currentUser?.email), where("status", "==", InviteStatus.pending)]


  let compositeQuery: QueryCompositeFilterConstraint =  and(...constraints)
// query(ref, compositeQuery , ...myNonFilterQuery);
  if (lastDocument) {
    myNonFilterQuery.push(startAfter(lastDocument))
  }
  // const q  = query(ref, ...myQuery);
  const q  = query(ref, compositeQuery , ...myNonFilterQuery);
  try {

    const querySnapshot = await getDocs(q);
    // querySnapshot.forEach((doc) => {
    //   // doc.data() is never undefined for query doc snapshots
    //   // console.log(doc.id, " => ", doc.data());
    //   let d = doc.data() as SKArtifact
    //   //let document = {id: d.id, }
      
    //   return doc.data() as SKArtifact
    // });

    const artifactsData = querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    })) as MemberInvite[];

    return artifactsData;
  } catch (err) {
    console.log(err)
    throw new CustomError('An error occurred while fetching data');
  }
};

const fetchMembersByInvitee = async (invitedBy:string,status:string,pageSize: number, lastDocument?:QueryDocumentSnapshot, isFlagged?:boolean ): Promise<MemberInvite[]> => {

  let ref = collection(db, "storeInvites")
  
  // let myQuery: QueryConstraint[] = []
  // myQuery.push(where(filterField, operator as WhereFilterOp, filterValue))

  let myNonFilterQuery: QueryNonFilterConstraint[] = []

  myNonFilterQuery.push(limit(pageSize ?? 10))

  //where("categories.entertainment", "==", true)
  let constraints = [ where("invitedByUserId", "==", invitedBy), where("status", "==", status)]

  let compositeQuery: QueryCompositeFilterConstraint =  and(...constraints)
// query(ref, compositeQuery , ...myNonFilterQuery);
  if (lastDocument) {
    myNonFilterQuery.push(startAfter(lastDocument))
  }
  // const q  = query(ref, ...myQuery);
  const q  = query(ref, compositeQuery , ...myNonFilterQuery);
  try {

    const querySnapshot = await getDocs(q);
    // querySnapshot.forEach((doc) => {
    //   // doc.data() is never undefined for query doc snapshots
    //   // console.log(doc.id, " => ", doc.data());
    //   let d = doc.data() as SKArtifact
    //   //let document = {id: d.id, }
      
    //   return doc.data() as SKArtifact
    // });

    const artifactsData = querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    })) as MemberInvite[];

    return artifactsData;
  } catch (err) {
    console.log(err)
    throw new CustomError('An error occurred while fetching data');
  }
};

const fetchInvitedMembers = async (pageSize: number, lastDocument?:QueryDocumentSnapshot, isFlagged?:boolean ): Promise<MemberInvite[]> => {

  let ref = collection(db, "storeInvites")
  
  // let myQuery: QueryConstraint[] = []
  // myQuery.push(where(filterField, operator as WhereFilterOp, filterValue))

  let myNonFilterQuery: QueryNonFilterConstraint[] = []

  myNonFilterQuery.push(limit(pageSize ?? 10))

  //where("categories.entertainment", "==", true)
  let constraints = [ where("invitedByUserId", "==", 'user@skarvo'), where("status", "==", InviteStatus.pending)]

  let compositeQuery: QueryCompositeFilterConstraint =  and(...constraints)
// query(ref, compositeQuery , ...myNonFilterQuery);
  if (lastDocument) {
    myNonFilterQuery.push(startAfter(lastDocument))
  }
  // const q  = query(ref, ...myQuery);
  const q  = query(ref, compositeQuery , ...myNonFilterQuery);
  try {

    const querySnapshot = await getDocs(q);
    // querySnapshot.forEach((doc) => {
    //   // doc.data() is never undefined for query doc snapshots
    //   // console.log(doc.id, " => ", doc.data());
    //   let d = doc.data() as SKArtifact
    //   //let document = {id: d.id, }
      
    //   return doc.data() as SKArtifact
    // });

    const artifactsData = querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    })) as MemberInvite[];

    return artifactsData;
  } catch (err) {
    console.log(err)
    throw new CustomError('An error occurred while fetching data');
  }
};


const fetchAdminMembers = async (pageSize: number, status:string, lastDocument?:QueryDocumentSnapshot, isFlagged?:boolean ): Promise<MemberInvite[]> => {

  let ref = collection(db, "storeInvites")

  let myNonFilterQuery: QueryNonFilterConstraint[] = []

  myNonFilterQuery.push(limit(pageSize ?? 10))

  let constraints = [ where("invitedByUserId", "==", 'user@skarvo'), where("status", "==", status)]

  let compositeQuery: QueryCompositeFilterConstraint =  and(...constraints)
// query(ref, compositeQuery , ...myNonFilterQuery);
  if (lastDocument) {
    myNonFilterQuery.push(startAfter(lastDocument))
  }
  // const q  = query(ref, ...myQuery);
  const q  = query(ref, compositeQuery , ...myNonFilterQuery);
  try {

    const querySnapshot = await getDocs(q);

    const artifactsData = querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    })) as MemberInvite[];

    return artifactsData;
  } catch (err) {
    console.log(err)
    throw new CustomError('An error occurred while fetching data');
  }
};

 const fetchChannelInvites = async (channelId:string,pageSize: number, lastDocument?:QueryDocumentSnapshot, isFlagged?:boolean ): Promise<MemberInvite[]> => {

  let ref = collection(db, "storeInvites")
  
  // let myQuery: QueryConstraint[] = []
  // myQuery.push(where(filterField, operator as WhereFilterOp, filterValue))

  let myNonFilterQuery: QueryNonFilterConstraint[] = []

  myNonFilterQuery.push(limit(pageSize ?? 10))

  //where("categories.entertainment", "==", true)
  let constraints = [ where("channelId", "==", channelId)]


  let compositeQuery: QueryCompositeFilterConstraint =  and(...constraints)
// query(ref, compositeQuery , ...myNonFilterQuery);
  if (lastDocument) {
    myNonFilterQuery.push(startAfter(lastDocument))
  }
  // const q  = query(ref, ...myQuery);
  const q  = query(ref, compositeQuery , ...myNonFilterQuery);
  try {

    const querySnapshot = await getDocs(q);
    // querySnapshot.forEach((doc) => {
    //   // doc.data() is never undefined for query doc snapshots
    //   // console.log(doc.id, " => ", doc.data());
    //   let d = doc.data() as SKArtifact
    //   //let document = {id: d.id, }
      
    //   return doc.data() as SKArtifact
    // });

    const artifactsData = querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    })) as MemberInvite[];

    return artifactsData;
  } catch (err) {
    console.log(err)
    throw new CustomError('An error occurred while fetching data');
  }
};

const updateInvite = async (invitationId: string, data: any) => {
    try {
      await updateDoc(doc(db, "storeInvites", invitationId), data);
    } catch (error) {
      console.error('An error occurred while updating user:', error);
      throw new CustomError('An error occurred while updating user');
    }
};

// const updateInvite = async ( data:any): Promise<any> => {
//   const updateInvitedMemberAndRole = httpsCallable(functions, 'updateInvitedMemberAndRole');
//   updateInvitedMemberAndRole(data).then((result) => {
//     console.log(result.data);
//     return result
//   }).catch((error) => {
//     console.error('Error updating Invite', error);
//     throw new CustomError('Error updating invite');
//   });
// };

const deleteInvite = async (inviteId: string) => {
  await deleteDoc(doc(db, "storeInvites", inviteId));
};

// Firebase Authentication services

export {
  inviteMember,
  setUserClaim,
  // acceptChannelInvitationAndJoin,
  // acceptSkarvoOperatorInvitation,
  acceptInvitation,
  updateInvite,
  fetchInvitedMembers,
  fetchAdminMembers,
  fetchMembersByInvitee,
  fetchMyInvitations,
  getInvitedMember,
  deleteInvite,
  getInviteDetail
};